














import Vue from 'vue';
import {Component} from 'vue-property-decorator';

@Component
export default class EmptyData extends Vue  {
    simpleImage: any;
  beforeCreate() {
    this.$store.commit('fetchRecords')
  }
  newRecord(){
    this.$router.push('/money')
  }
}
